import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark border-t border-brand-white/10 py-12 md:py-16 px-4 text-center" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <div className="inline-flex items-center gap-2 text-brand-gold font-black text-2xl mb-8" data-id="element-39">
          <span data-id="element-40">🐾</span> TU MANUAL DIGITAL
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-sm md:text-base text-brand-cream/80 mb-10 font-bold" data-id="element-41">
          <a href="https://tumanualdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-42">
            tumanualdigital.com
          </a>
          <span className="hidden md:block text-brand-muted" data-id="element-43">•</span>
          <a href="mailto:soporte.tumanualdigital@gmail.com" className="hover:text-brand-gold transition-colors" data-id="element-44">
            soporte.tumanualdigital@gmail.com
          </a>
          <span className="hidden md:block text-brand-muted" data-id="element-45">•</span>
          <a href="https://instagram.com/tu.manualdigital" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-46">
            @tu.manualdigital
          </a>
        </div>

        <div className="text-xs md:text-sm text-brand-muted space-y-2 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-47">
          <p data-id="element-48">
            Este material es de uso profesional exclusivo del comprador.
            Prohibida su reproducción o reventa sin autorización escrita de Tu
            Manual Digital.
          </p>
          <p data-id="element-49">© 2025 Tu Manual Digital. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}